import TabPanel from './TabPanel';

export default TabPanel;
export * from './types';
export { TabPanel };
